import React, { Component, Fragment } from "react";
import Select from "react-select";
import { utcs } from "../../Constants/times";
import "./index.css";
const Styles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    width: 80,
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: 14,
  }),
};
const UTCStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    width: 135,
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: 14,
  }),
};
const options = [
  { label: "AM", value: "am" },
  { label: "PM", value: "pm" },
];
class TimeInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      option: { value: "am", label: "AM" },
      utc: { label: "UTC+00:00", value: 0 },
      hh: "00",
      mm: "00",
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      const { time } = this.props;
      if (time) {
        this.setState({
          hh: time.hh,
          mm: time.mm,
          utc: utcs.find((u) => u.value === time.utc) || {
            label: "UTC+00:00",
            value: 0,
          },
          option: options.find((op) => op.value === time.of) || {
            value: "am",
            label: "AM",
          },
        });
      }
    }
  }
  handleSelectChange = (option) => {
    this.setState({ option });
    const { hh, mm, utc } = this.state;
    const { onChange } = this.props;
    let obj = {
      hh: hh,
      mm: mm,
      of: option.value,
      utc: utc.value,
    };
    onChange(obj);
  };
  handleUTCSelectChange = (utc) => {
    this.setState({ utc });
    const { hh, mm, option } = this.state;
    const { onChange } = this.props;
    let obj = {
      hh: hh,
      mm: mm,
      of: option.value,
      utc: utc.value,
    };
    onChange(obj);
  };
  onChangeInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    const { option, hh, mm, utc } = this.state;
    const { onChange } = this.props;
    let obj = {
      hh: hh,
      mm: mm,
      [e.target.name]: e.target.value,
      of: option.value,
      utc: utc.value,
    };
    onChange(obj);
  };
  render() {
    const { option, hh, mm, utc } = this.state;

    return (
      <div className="time-container">
        <input
          className="form-control"
          type="number"
          placeholder="HH"
          name="hh"
          max="12"
          min="0"
          onChange={this.onChangeInput}
          value={hh}
        />
        &nbsp;:&nbsp;
        <input
          className="form-control"
          type="number"
          placeholder="MM"
          name="mm"
          max="59"
          min="0"
          onChange={this.onChangeInput}
          value={mm}
        />
        &nbsp;&nbsp;&nbsp;
        <Select
          value={option}
          onChange={this.handleSelectChange}
          options={options}
          styles={Styles}
        />
        &nbsp;&nbsp;&nbsp;
        <Select
          value={utc}
          onChange={this.handleUTCSelectChange}
          options={utcs}
          styles={UTCStyles}
        />
      </div>
    );
  }
}

export default TimeInput;



// WEBPACK FOOTER //
// ./src/components/TimeInput/index.js